import { render, staticRenderFns } from "./ShareDetails.vue?vue&type=template&id=35006a78"
import script from "./ShareDetails.vue?vue&type=script&lang=js"
export * from "./ShareDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports